/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  Button,
  ButtonGroup,
  CircularProgress,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TableContainer,
  Tooltip,
} from "@mui/material";
import React from "react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

import moment from "moment";
import useVolunteer from "../../hooks/useVolunteer";
import TableComp from "../table-components/table/TableComp";
import Pagination from "../table-components/pagination/Pagination";
import { BsFillPrinterFill } from "react-icons/bs";
import ReportFilter from "../table-components/filter/ReportFilter";
import DateRangeFilter from "./DateRangeFilter";
import ColumnFilter from "../table-components/ColumnFilter/ColumnFilter";
import { PdfDiv } from "./DashboardInfo.style";
import { handleViewOpen, rowValue } from "../../redux/Reducer/ModalSlice";
import { useDispatch } from "react-redux";
import ViewModal from "../modal/ViewModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VolunteerProfile from "../Volunteer/VolunteerProfile";

const ApproveVolunteerList = () => {
  const dispatch = useDispatch();
  const [volunteerInfo, isLoading] = useVolunteer();

  function handleView(rowData) {
    dispatch(handleViewOpen());
    dispatch(rowValue(rowData));
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date_of_registration",
        Cell: (row) => (
          <div>
            {moment(row.row.original.date_of_registration).format(
              "DD MMM YYYY"
            )}
          </div>
        ),
        Filter: DateRangeFilter,
        filter: (rows, id, filterValue) => {
          const { startDate, endDate } = filterValue || {};
          if (!startDate && !endDate) return rows;
          return rows.filter((row) => {
            const date = new Date(row.values[id]);
            return (
              (!startDate || date >= new Date(startDate)) &&
              (!endDate || date <= new Date(endDate))
            );
          });
        },
      },
      {
        Header: "PID No",
        accessor: "vol_id",
        Filter: ColumnFilter,
      },
      {
        Header: "Name",
        accessor: "full_name",
        Filter: false,
      },

      {
        Header: "Date of Birth",
        accessor: "dob",
        Cell: (row) => (
          <div>{moment(row.row.original.dob).format("DD MMM YYYY")}</div>
        ),
        Filter: false,
      },
      {
        Header: "Sex",
        accessor: "sex",
        Filter: false,
      },

      {
        Header: "Occupation",
        accessor: "occupation_name",
        Filter: false,
      },

      {
        Header: "Contact Number",
        accessor: "contact_phone",
        Filter: false,
      },

      {
        Header: () => <div style={{ marginLeft: "20px" }}>Action</div>,
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* edit icon */}
            {/* {(user === "Admin" || user === "Developer") && (
              <IconButton
                size="small"
                sx={{ "&:hover": { color: "#2e68e8" } }}
                style={{ color: "#2196F3" }}
                variant="none"
                onClick={() => handleEdit(row.row.original)}
              >
                <Tooltip title="Update">
                  <EditIcon
                    // fontSize="small"
                    sx={{ fontSize: 18 }}
                  />
                </Tooltip>
              </IconButton>
            )} */}

            {/* <MouseDiv>  */}

            {/* preview details icon */}
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#189A2E" }}
              variant="none"
              onClick={() => handleView(row.row.original)}
            >
              <Tooltip title="Details">
                <VisibilityIcon
                  sx={{ fontSize: 18 }}
                  // fontSize="small"
                />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: volunteerInfo },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "5px",
          marginBottom: "5px",
        }}
      >
        <div className="entries">
          Show Entries:{" "}
          <Select
            size="small"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            <MenuItem value={10}> 10 </MenuItem>
            <MenuItem value={volunteerInfo?.length}> All </MenuItem>
          </Select>
        </div>
        <div>
          <ReportFilter filter={globalFilter} setFilter={setGlobalFilter} />
        </div>
        <PdfDiv
          style={{
            display: "flex",
            gap: "5px",
          }}
        >
          <Button
            className="entries"
            onClick={() => window.print()}
            variant="outlined"
            startIcon={<BsFillPrinterFill />}
          >
            PDF Download
          </Button>
        </PdfDiv>
      </div>
      <TableContainer component={Paper}>
        <TableComp
          sortIcon="sort-icon"
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }}
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>

      {/* preview modal */}
      <ViewModal ModalWidth="md" ModalTitle="Volunteer Profile">
        <VolunteerProfile />
      </ViewModal>
    </>
  );
};

export default ApproveVolunteerList;
